const API_BASE = ""; // same-origin: the Node server serves both the API and this app

function getToken() {
  return localStorage.getItem("ilms_token");
}

export function setToken(token) {
  if (token) localStorage.setItem("ilms_token", token);
  else localStorage.removeItem("ilms_token");
}

function getTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

async function request(method, path, body, opts = {}) {
  const headers = { "X-Client-Timezone": getTimezone() };
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;

  let payload = body;
  if (body && !(body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }

  const res = await fetch(API_BASE + path, { method, headers, body: payload });
  let data = null;
  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    data = await res.json().catch(() => null);
  }
  if (!res.ok) {
    const message = (data && data.error) || `Request failed (${res.status})`;
    if (res.status === 401 && !opts.silentAuth) setToken(null);
    throw new Error(message);
  }
  return data;
}

export const api = {
  get: (path) => request("GET", path),
  post: (path, body, opts) => request("POST", path, body, opts),
  put: (path, body) => request("PUT", path, body),
  del: (path) => request("DELETE", path),
};
